
import { fetchApi } from '../../../../lib/fetchApi';
import { useCallback, useEffect, useState } from "react";
import { GetFilters, UseGetReasonsClosedObjectResult } from '../types';
import { userLanguageToDescriptionField } from '../../../../utils/formatters/UserLanguageToDescriptionField';
import { Pagination } from '../../../../types/Pagination';
import { ListFields } from '../../Dictionaries/types';


interface UseGetReasonsClosedResult {
    reasonClosedData: UseGetReasonsClosedObjectResult[];
    fetchReasonClosedData: () => Promise<UseGetReasonsClosedObjectResult[] | null>;
}

export const useGetReasonsClosed = (): UseGetReasonsClosedResult => {

    const [reasonClosedData, setReasonClosedData] = useState<UseGetReasonsClosedObjectResult[]>([]);

    const fetchReasonClosedData = useCallback(async (): Promise<UseGetReasonsClosedObjectResult[] | null> => {
        try {

            const body: GetFilters = {
                pageNumber: 1,
                pageSize: 10
            };
            const response = await fetchApi.post('/surveyClosedReason/search', body) as Pagination<ListFields>;

            const userLanguage = userLanguageToDescriptionField();

            // Transformar la respuesta
            const transformedData = response.items.map(item => ({
                id: item.id,
                name: item.description[userLanguage as keyof typeof item.description]
                    || item.description.english
                    || item.description.spanish
                    || item.description.catalan
                    || '' // Fallback
            }));

            setReasonClosedData(transformedData);
            return transformedData;

        } catch (err) {
            console.log(err);
            return null;
        }
    }, []);

    useEffect(() => {
        fetchReasonClosedData();
    }, []);
    
    return { reasonClosedData, fetchReasonClosedData };
}